import Icon from './Icon';
export * from './Icon';
export * from './styles/icon.styled';
export * from './types';
export * from './utils/uiExceptions';
export default Icon;
//# sourceMappingURL=index.js.map